// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ANa2","productName":"Table_productName__1gZTT"};